export interface 譲渡譲受医療機関型 {
  譲渡譲受医療機関コード: string;
  譲渡譲受医療機関名: string;
  譲渡譲受医療機関名カナ: string;
  譲渡譲受住所1: string;
  譲渡譲受住所2: string;
  譲渡譲受電話番号: string;
  譲渡譲受FAX番号: string;
  譲渡譲受表示順: number;
  更新バージョン: number;
  削除フラグ: 削除フラグ型;
}

export enum 削除フラグ型 {
  未削除 = '未削除',
  削除 = '削除',
}

export const 譲渡譲受医療機関初期値 = {
  譲渡譲受医療機関コード: '',
  譲渡譲受医療機関名: '',
  譲渡譲受医療機関名カナ: '',
  譲渡譲受住所1: '',
  譲渡譲受住所2: '',
  譲渡譲受電話番号: '',
  譲渡譲受FAX番号: '',
  譲渡譲受表示順: 0,
  更新バージョン: 0,
  削除フラグ: 削除フラグ型.未削除,
};

export interface 譲渡譲受医療機関削除依頼型 {
  医療機関コード: string;
  更新バージョン: number;
}
